<template>
  <div class="ssocial-share-bar">
    <vue-goodshare-facebook :page_url="currentUrl" has_icon title_social="Facebook"></vue-goodshare-facebook>
    <vue-goodshare-twitter :page_url="currentUrl" has_icon title_social="Twitter"></vue-goodshare-twitter>
    <vue-goodshare-email :page_url="currentUrl" has_icon title_social="Email"></vue-goodshare-email>
    <vue-goodshare-sms :page_url="currentUrl" has_icon title_social="SMS"></vue-goodshare-sms>
  </div>
</template>

<script>
  import VueGoodshareFacebook from "vue-goodshare/src/providers/Facebook.vue";
  import VueGoodshareTwitter from "vue-goodshare/src/providers/Twitter.vue";
  import VueGoodshareEmail from "vue-goodshare/src/providers/Email.vue";
  import VueGoodshareSms from "vue-goodshare/src/providers/SMS.vue";

  export default {
    name: 'SocialShareBar',

    components: {
      VueGoodshareFacebook,
      VueGoodshareTwitter,
      VueGoodshareEmail,
      VueGoodshareSms
    },

    computed: {

      currentUrl: function () {
        return window.location.href;
      }

    }
  }
</script>
